var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPls2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.57 150.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#6b7b84;}.cls-2{fill:#231f20;}.cls-3{fill:#812990;}.cls-4{font-size:9px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-5,.cls-6{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-6{stroke-dasharray:1.98 1.98;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,75.2v1.54H2.32V68H8.78v1.54H4.05v2.22H8v1.49h-4v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.45,67.38v9.36H16.71v-.41a3.92,3.92,0,0,1-2,.53,3.49,3.49,0,0,1,0-7,4.08,4.08,0,0,1,2,.5v-3Zm-1.74,7.33V72a2.55,2.55,0,0,0-1.65-.57,1.93,1.93,0,0,0-2,1.94,1.9,1.9,0,0,0,2,1.92A2.53,2.53,0,0,0,16.71,74.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.79,70v6.74H26.06V76.3a3.27,3.27,0,0,1-1.84.54c-2,0-2.88-.92-2.88-3.1V70h1.73v3.74c0,1,.51,1.55,1.47,1.55a2.3,2.3,0,0,0,1.52-.53V70Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.74,75.49a3.25,3.25,0,0,1-2.61,1.35,3.49,3.49,0,1,1,0-7,3.25,3.25,0,0,1,2.63,1.34l-1.12,1a1.81,1.81,0,0,0-1.51-.82,1.93,1.93,0,1,0,0,3.86,1.8,1.8,0,0,0,1.51-.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.12,70v6.74H44.39v-.49a3.55,3.55,0,0,1-2,.59,3.49,3.49,0,0,1,0-7,4,4,0,0,1,2,.56V70Zm-1.73,2a2.58,2.58,0,0,0-1.67-.58,1.93,1.93,0,1,0,0,3.86,2.55,2.55,0,0,0,1.67-.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.2,71.43v2.38c0,1.21.2,1.55,1.07,1.55a5.92,5.92,0,0,0,.79-.06v1.29a4,4,0,0,1-1.56.25,1.93,1.93,0,0,1-2-2.12V71.43h-1V70h1V67.38H51.2V70h1.89v1.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.52,68.26a1,1,0,1,1,2,0,1,1,0,1,1-2,0ZM55.65,70h1.73v6.74H55.65Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.44,73.37a3.7,3.7,0,1,1-3.69-3.49A3.58,3.58,0,0,1,67.44,73.37Zm-1.7,0a2,2,0,1,0-2,1.92A2,2,0,0,0,65.74,73.37Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.51,73v3.76H74.78V73c0-1-.5-1.55-1.46-1.55a2.22,2.22,0,0,0-1.49.53v4.78H70.1V70h1.73v.42a3.07,3.07,0,0,1,1.8-.54C75.61,69.88,76.51,70.79,76.51,73Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.36,72.86a15.93,15.93,0,0,1-1.33,2l1.06,1-1,1-1-1a3.82,3.82,0,0,1-2.33,1c-2,0-3.31-.94-3.31-2.54A2.64,2.64,0,0,1,86.28,72a2.33,2.33,0,0,1-.77-1.69,2.49,2.49,0,0,1,5-.19,2.68,2.68,0,0,1-1.89,2.4l1.51,1.43a10,10,0,0,0,1-1.44Zm-3.19,2.06-2-1.91c-.7.28-1,.72-1,1.23s.6,1.21,1.65,1.21A2.09,2.09,0,0,0,89.17,74.92ZM87,70.31a1.74,1.74,0,0,0,.78,1.25c.55-.17,1.3-.57,1.3-1.26A1.06,1.06,0,0,0,88,69.14,1.1,1.1,0,0,0,87,70.31Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.76,68h1.94l-4.09,8.75h-.82L99.71,68h1.93l2.56,5.71Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.88,68.26a1,1,0,1,1,2,0,1,1,0,1,1-2,0ZM111,70h1.72v6.74H111Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,74.92a5.42,5.42,0,0,0,2.32.54c.79,0,1.1-.29,1.1-.64s-.38-.56-1.43-.78c-1.45-.33-2.51-.8-2.51-2.1s1-2.06,2.57-2.06a6.75,6.75,0,0,1,2.64.54l-.57,1.27a6.26,6.26,0,0,0-2.1-.44c-.66,0-1,.24-1,.6s.41.55,1.49.77c1.57.32,2.48.87,2.48,2.1s-1,2.12-2.71,2.12a6,6,0,0,1-2.92-.64Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.43,70v6.74h-1.72v-.49a3.58,3.58,0,0,1-2,.59,3.49,3.49,0,0,1,0-7,4.06,4.06,0,0,1,2,.56V70Zm-1.72,2a2.6,2.6,0,0,0-1.67-.58,1.93,1.93,0,1,0,0,3.86,2.57,2.57,0,0,0,1.67-.57Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.56,74.17c0,1.69-1.35,2.69-3.39,2.69a6.79,6.79,0,0,1-3.65-.84l.65-1.38a6.25,6.25,0,0,0,3.06.68c1,0,1.53-.35,1.53-1s-.58-.86-1.87-1.15c-1.8-.41-3.25-.92-3.25-2.65,0-1.54,1.23-2.63,3.23-2.63a8.41,8.41,0,0,1,3.36.71L144.51,70a7.81,7.81,0,0,0-2.68-.58c-.89,0-1.39.4-1.39.94s.62.88,1.94,1.18C144.27,72,145.56,72.57,145.56,74.17Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.66,73.86a1.86,1.86,0,0,0,1.93,1.5,2.17,2.17,0,0,0,1.74-.83l1.1.92a3.69,3.69,0,0,1-3,1.39,3.48,3.48,0,0,1,0-7c2.07,0,3.28,1.5,3.28,3.6,0,.13,0,.27,0,.38Zm0-1.1H153a1.5,1.5,0,0,0-1.63-1.51A1.76,1.76,0,0,0,149.67,72.76Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.05,70.94a2.57,2.57,0,0,1,2.13-1.06,1.32,1.32,0,0,1,.42.07v1.88a4.86,4.86,0,0,0-.83-.1,1.62,1.62,0,0,0-1.72,1.76v3.25h-1.74V70h1.74Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.86,70l-3.24,6.74h-.82L163.56,70h1.81l1.84,3.82L169,70Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.15,68.26a1,1,0,1,1,2,0,1,1,0,1,1-2,0Zm.13,1.74H175v6.74h-1.73Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184,75.49a3.26,3.26,0,0,1-2.62,1.35,3.49,3.49,0,1,1,0-7A3.26,3.26,0,0,1,184,71.22l-1.12,1a1.82,1.82,0,0,0-1.52-.82,1.93,1.93,0,1,0,0,3.86,1.8,1.8,0,0,0,1.52-.83Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.83,73.86a1.86,1.86,0,0,0,1.93,1.5,2.18,2.18,0,0,0,1.74-.83l1.1.92a3.7,3.7,0,0,1-3,1.39,3.48,3.48,0,0,1,0-7c2.07,0,3.28,1.5,3.28,3.6,0,.13,0,.27,0,.38Zm0-1.1h3.35a1.5,1.5,0,0,0-1.63-1.51A1.76,1.76,0,0,0,187.84,72.76Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.75,74.92a5.42,5.42,0,0,0,2.32.54c.79,0,1.1-.29,1.1-.64s-.38-.56-1.43-.78c-1.45-.33-2.51-.8-2.51-2.1s1-2.06,2.58-2.06a6.74,6.74,0,0,1,2.63.54l-.57,1.27a6.26,6.26,0,0,0-2.1-.44c-.66,0-1,.24-1,.6s.41.55,1.5.77c1.56.32,2.47.87,2.47,2.1s-1,2.12-2.71,2.12a6,6,0,0,1-2.92-.64Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.66,1.31H193V6h-1V1.31h-1.67v-1h4.3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.74.33V6h-1V2L197.9,4.88,196,2V6h-1V.33h1.06l1.78,2.76L199.68.33Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.27,15v1.82a13,13,0,0,0-3.22-1.73,11.79,11.79,0,0,0-4.18-.68,12.59,12.59,0,0,0-4.88.93A11.88,11.88,0,0,0,29.12,18a11.76,11.76,0,0,0-2.54,3.83,12.49,12.49,0,0,0,0,9.36A11.87,11.87,0,0,0,29.12,35,12,12,0,0,0,33,37.56a12.59,12.59,0,0,0,4.88.93h.48a13.16,13.16,0,0,0,4.92-.92V31.08l0,0A6.79,6.79,0,0,1,41,32.54a7.27,7.27,0,0,1-2.64.48,8.32,8.32,0,0,1-1.12-.09h0a7.49,7.49,0,0,1-1.55-.39,6.21,6.21,0,0,1-2.23-1.44,6.32,6.32,0,0,1,0-9.26,6.9,6.9,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5,6.86,6.86,0,0,1,4.9,1.92,6.19,6.19,0,0,1,2,4.65v12H51V15Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.86,38.49,8.08,26.16V38.49H2.32V6H8.08V18.29L20.86,6.05H29L12.16,22.22,29,38.49Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66,14.45a10.58,10.58,0,0,1,4.28.84,9.7,9.7,0,0,1,3.29,2.33,10.43,10.43,0,0,1,2.11,3.44,11.68,11.68,0,0,1,.75,4.2V38.49H70.68V25.26A4.89,4.89,0,0,0,69,21.47a5.53,5.53,0,0,0-3.94-1.55,5.6,5.6,0,0,0-4,1.55,5.07,5.07,0,0,0-1.63,3.79V38.49H53.68V15.08h5.76v1.74a11.5,11.5,0,0,1,2.93-1.71A9.68,9.68,0,0,1,66,14.45Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.17,15.08A10.38,10.38,0,0,1,148,14.4v5.47a6.86,6.86,0,0,0-4.9,1.92,6.38,6.38,0,0,0-2,4.65V38.49h-5.77V15h5.77v1.78A12.42,12.42,0,0,1,144.17,15.08Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.08,14.45a13.13,13.13,0,0,1,4.95.93,12.82,12.82,0,0,1,4,2.58,11.94,11.94,0,0,1,2.72,3.83,11.66,11.66,0,0,1,0,9.36A12.05,12.05,0,0,1,170.06,35a13,13,0,0,1-4,2.58A13.17,13.17,0,0,1,152.09,35a12.18,12.18,0,0,1-2.71-3.83,11.66,11.66,0,0,1,0-9.36A12.07,12.07,0,0,1,152.09,18a12.86,12.86,0,0,1,4-2.58A13.13,13.13,0,0,1,161.08,14.45Zm0,5.47a6.84,6.84,0,0,0-4.9,1.92,6.32,6.32,0,0,0,0,9.26,6.21,6.21,0,0,0,2.23,1.44,7.52,7.52,0,0,0,2.67.48,7.27,7.27,0,0,0,2.64-.48A6.79,6.79,0,0,0,166,31.1a6.32,6.32,0,0,0,0-9.26A7.06,7.06,0,0,0,161.08,19.92Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.06,14.45a13,13,0,0,1,4.94.93A12.75,12.75,0,0,1,197,18a12.1,12.1,0,0,1,2.72,3.83,11.66,11.66,0,0,1,0,9.36A12.21,12.21,0,0,1,197,35a12.92,12.92,0,0,1-9,3.51,12.92,12.92,0,0,1-9-3.51,12,12,0,0,1-2.71-3.83,11.56,11.56,0,0,1,0-9.36A11.92,11.92,0,0,1,179.07,18a12.86,12.86,0,0,1,4-2.58A13.09,13.09,0,0,1,188.06,14.45Zm0,5.47a6.82,6.82,0,0,0-4.9,1.92,6.32,6.32,0,0,0,0,9.26,6.12,6.12,0,0,0,2.23,1.44,7.52,7.52,0,0,0,2.67.48,7.31,7.31,0,0,0,2.64-.48A6.89,6.89,0,0,0,193,31.1a6.32,6.32,0,0,0,0-9.26A7.08,7.08,0,0,0,188.06,19.92Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.4,15v1.82a13,13,0,0,0-3.22-1.73,11.79,11.79,0,0,0-4.18-.68,12.59,12.59,0,0,0-4.88.93,11.72,11.72,0,0,0-6.41,6.41,12,12,0,0,0,6.41,15.77,12.59,12.59,0,0,0,4.88.93h.48a13.16,13.16,0,0,0,4.92-.92V31.08l0,0a6.79,6.79,0,0,1-2.26,1.44,7.27,7.27,0,0,1-2.64.48,8.32,8.32,0,0,1-1.12-.09h0a7.49,7.49,0,0,1-1.55-.39,6.21,6.21,0,0,1-2.23-1.44,6.32,6.32,0,0,1,0-9.26,6.9,6.9,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5,6.86,6.86,0,0,1,4.9,1.92,6.19,6.19,0,0,1,2,4.65v12h5.76V15Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.45,15v1.82a12.83,12.83,0,0,0-3.22-1.73,10.91,10.91,0,0,0-2.08-.53,15,15,0,0,0-2.48-.2,12.09,12.09,0,0,0-4.78.93,11.31,11.31,0,0,0-3.75,2.58,12,12,0,0,0-2.43,3.84,12.77,12.77,0,0,0-.86,4.69v0a12,12,0,0,0,.91,4.66A11.89,11.89,0,0,0,82.31,35a12,12,0,0,0,3.87,2.58,12.54,12.54,0,0,0,4.87.93h.58l.27,0a13.08,13.08,0,0,0,4.56-.9V31.08l0,0a6.75,6.75,0,0,1-2.25,1.44,7.37,7.37,0,0,1-2.65.48,8,8,0,0,1-1.11-.09h0a7.49,7.49,0,0,1-1.55-.39,6.25,6.25,0,0,1-2.24-1.44,6.15,6.15,0,0,1-2-4.63A6.3,6.3,0,0,1,85.09,24l.08-.18a6.54,6.54,0,0,1,1.46-2,7,7,0,0,1,2.24-1.42,7.26,7.26,0,0,1,2.66-.5,6.82,6.82,0,0,1,4.9,1.92,6.42,6.42,0,0,1,1.47,2A1.42,1.42,0,0,0,98,24a6.4,6.4,0,0,1,.47,2.45v9.13a6.09,6.09,0,0,1-2,4.6,6.65,6.65,0,0,1-4.9,2,6.75,6.75,0,0,1-3.46-.91L83.89,45.2A12.89,12.89,0,0,0,87.45,47a13.28,13.28,0,0,0,9-.32,12.92,12.92,0,0,0,4-2.6,11.92,11.92,0,0,0,2.71-3.83,11.16,11.16,0,0,0,1-4.65V15Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,58.33v1.53H2.32V51.13H8.75v1.54H4v2.21H8v1.49H4v2Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.07,50.41v9.34H18.34v-.41a4,4,0,0,1-2,.52,3.48,3.48,0,0,1,0-7,4.08,4.08,0,0,1,2,.51v-3Zm-1.73,7.31V55a2.53,2.53,0,0,0-1.65-.57,1.92,1.92,0,0,0-2,1.93,1.89,1.89,0,0,0,2,1.92A2.53,2.53,0,0,0,18.34,57.72Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.07,53v6.72H29.35v-.44a3.3,3.3,0,0,1-1.84.54c-2,0-2.87-.91-2.87-3.09V53h1.72v3.73c0,1,.51,1.54,1.46,1.54a2.29,2.29,0,0,0,1.53-.53V53Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.67,58.51a3.24,3.24,0,0,1-2.6,1.35,3.48,3.48,0,1,1,0-6.94,3.27,3.27,0,0,1,2.62,1.33l-1.11,1a1.86,1.86,0,0,0-1.51-.82,1.93,1.93,0,1,0,0,3.85,1.82,1.82,0,0,0,1.51-.83Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.7,53v6.72H51v-.49a3.55,3.55,0,0,1-2,.59,3.48,3.48,0,0,1,0-7,4,4,0,0,1,2,.56V53ZM51,55a2.63,2.63,0,0,0-1.66-.58,1.93,1.93,0,1,0,0,3.85A2.55,2.55,0,0,0,51,57.74Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.45,54.46v2.38c0,1.2.2,1.55,1.06,1.55.3,0,.56,0,.79-.06v1.28a4,4,0,0,1-1.56.25,1.93,1.93,0,0,1-2-2.12V54.46h-1V53h1V50.43h1.74V53h1.88v1.42Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.44,51.4a1,1,0,0,1,1-1,1,1,0,1,1-1,1Zm.14,1.74H67.3v6.72H65.58Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79,56.39a3.68,3.68,0,1,1-3.68-3.47A3.58,3.58,0,0,1,79,56.39Zm-1.7,0a2,2,0,1,0-2,1.92A1.95,1.95,0,0,0,77.31,56.39Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.73,56.11v3.75H88V56.11c0-1-.51-1.55-1.46-1.55a2.19,2.19,0,0,0-1.48.53v4.77H83.34V53.14h1.73v.42A3.06,3.06,0,0,1,86.86,53C88.83,53,89.73,53.93,89.73,56.11Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.24,52.67v3.11h4.18v1.53h-4.18v2.55h-1.72V51.13h6.58v1.54Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.22,56.39a3.69,3.69,0,1,1-3.68-3.47A3.58,3.58,0,0,1,119.22,56.39Zm-1.7,0a2,2,0,1,0-2,1.92A2,2,0,0,0,117.52,56.39Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.9,53v6.72h-1.72v-.44a3.29,3.29,0,0,1-1.83.54c-2,0-2.87-.91-2.87-3.09V53h1.72v3.73c0,1,.5,1.54,1.46,1.54a2.26,2.26,0,0,0,1.52-.53V53Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141,56.11v3.75h-1.72V56.11c0-1-.51-1.55-1.47-1.55a2.21,2.21,0,0,0-1.48.53v4.77h-1.72V53.14h1.72v.42a3.06,3.06,0,0,1,1.79-.55C140,53,141,53.93,141,56.11Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.31,50.41v9.34h-1.73v-.41a4,4,0,0,1-2,.52,3.48,3.48,0,0,1,0-7,4.08,4.08,0,0,1,2,.51v-3Zm-1.73,7.31V55a2.53,2.53,0,0,0-1.65-.57,1.92,1.92,0,0,0-2,1.93,1.89,1.89,0,0,0,2,1.92A2.51,2.51,0,0,0,150.58,57.72Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.7,53v6.72H162v-.49a3.49,3.49,0,0,1-2,.59,3.48,3.48,0,0,1,0-7,4,4,0,0,1,2,.56V53ZM162,55a2.61,2.61,0,0,0-1.66-.58,1.93,1.93,0,1,0,0,3.85,2.53,2.53,0,0,0,1.66-.57Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.45,54.46v2.38c0,1.2.2,1.55,1.07,1.55.3,0,.56,0,.79-.06v1.28a4,4,0,0,1-1.56.25,1.93,1.93,0,0,1-2-2.12V54.46h-.95V53h.95V50.43h1.73V53h1.89v1.42Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.45,51.4a1,1,0,1,1,1,1A1,1,0,0,1,176.45,51.4Zm.13,1.74h1.72v6.72h-1.72Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190,56.39a3.69,3.69,0,1,1-3.68-3.47A3.58,3.58,0,0,1,190,56.39Zm-1.7,0a2,2,0,1,0-2,1.92A2,2,0,0,0,188.32,56.39Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.74,56.11v3.75H199V56.11c0-1-.51-1.55-1.46-1.55a2.24,2.24,0,0,0-1.49.53v4.77h-1.72V53.14h1.72v.42a3.12,3.12,0,0,1,1.8-.55C199.84,53,200.74,53.93,200.74,56.11Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(197.99 147.64)"
  }, "0")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(264.06 79.54)"
  }, "0")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.29 51.04)"
  }, "1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(264.17 22.55)"
  }, "2")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(170.87 147.64)"
  }, "1")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(141.4 147.64)"
  }, "2")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(113.2 147.64)"
  }, "3")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(84.84 147.64)"
  }, "4")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(56.35 147.64)"
  }, "5")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(28 147.64)"
  }, "6")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 147.64)"
  }, "7")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 5.75,
    x2: 200.74,
    y2: 133.54
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 197.91,
    y1: 76.84,
    x2: 197.91,
    y2: 105.19
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 195.07,
    y1: 76.84,
    x2: 195.07,
    y2: 105.19
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 192.24,
    y1: 76.84,
    x2: 192.24,
    y2: 105.19
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 189.4,
    y1: 76.84,
    x2: 189.4,
    y2: 105.19
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 186.57,
    y1: 76.84,
    x2: 186.57,
    y2: 119.36
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 183.73,
    y1: 76.84,
    x2: 183.73,
    y2: 105.19
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 180.9,
    y1: 76.84,
    x2: 180.9,
    y2: 105.19
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 178.06,
    y1: 76.84,
    x2: 178.06,
    y2: 105.19
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 175.23,
    y1: 76.84,
    x2: 175.23,
    y2: 105.19
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 172.39,
    y1: 76.84,
    x2: 172.39,
    y2: 133.54
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 169.56,
    y1: 76.84,
    x2: 169.56,
    y2: 105.19
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 166.72,
    y1: 76.84,
    x2: 166.72,
    y2: 105.19
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 163.89,
    y1: 76.84,
    x2: 163.89,
    y2: 105.19
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 161.06,
    y1: 76.84,
    x2: 161.06,
    y2: 105.19
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 158.22,
    y1: 76.84,
    x2: 158.22,
    y2: 119.36
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 155.39,
    y1: 76.84,
    x2: 155.39,
    y2: 105.19
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 152.55,
    y1: 76.84,
    x2: 152.55,
    y2: 105.19
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 149.72,
    y1: 76.84,
    x2: 149.72,
    y2: 105.19
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 146.88,
    y1: 76.84,
    x2: 146.88,
    y2: 105.19
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 144.05,
    y1: 76.84,
    x2: 144.05,
    y2: 133.54
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 141.21,
    y1: 76.84,
    x2: 141.21,
    y2: 105.19
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 138.38,
    y1: 76.84,
    x2: 138.38,
    y2: 105.19
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 135.54,
    y1: 76.84,
    x2: 135.54,
    y2: 105.19
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 132.71,
    y1: 76.84,
    x2: 132.71,
    y2: 105.19
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 129.87,
    y1: 76.84,
    x2: 129.87,
    y2: 119.36
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.04,
    y1: 76.84,
    x2: 127.04,
    y2: 105.19
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 124.2,
    y1: 76.84,
    x2: 124.2,
    y2: 105.19
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 121.37,
    y1: 76.84,
    x2: 121.37,
    y2: 105.19
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 118.54,
    y1: 76.84,
    x2: 118.54,
    y2: 105.19
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 115.7,
    y1: 76.84,
    x2: 115.7,
    y2: 133.54
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 112.87,
    y1: 76.84,
    x2: 112.87,
    y2: 105.19
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 110.03,
    y1: 76.84,
    x2: 110.03,
    y2: 105.19
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 107.2,
    y1: 76.84,
    x2: 107.2,
    y2: 105.19
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 104.36,
    y1: 76.84,
    x2: 104.36,
    y2: 105.19
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 101.53,
    y1: 76.84,
    x2: 101.53,
    y2: 119.36
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 98.69,
    y1: 76.84,
    x2: 98.69,
    y2: 105.19
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 95.86,
    y1: 76.84,
    x2: 95.86,
    y2: 105.19
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 93.02,
    y1: 76.84,
    x2: 93.02,
    y2: 105.19
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.19,
    y1: 76.84,
    x2: 90.19,
    y2: 105.19
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 87.35,
    y1: 76.84,
    x2: 87.35,
    y2: 133.54
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.52,
    y1: 76.84,
    x2: 84.52,
    y2: 105.19
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 81.69,
    y1: 76.84,
    x2: 81.69,
    y2: 105.19
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 78.85,
    y1: 76.84,
    x2: 78.85,
    y2: 105.19
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 76.02,
    y1: 76.84,
    x2: 76.02,
    y2: 105.19
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 73.18,
    y1: 76.84,
    x2: 73.18,
    y2: 119.36
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 70.35,
    y1: 76.84,
    x2: 70.35,
    y2: 105.19
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 67.51,
    y1: 76.84,
    x2: 67.51,
    y2: 105.19
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 64.68,
    y1: 76.84,
    x2: 64.68,
    y2: 105.19
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 61.84,
    y1: 76.84,
    x2: 61.84,
    y2: 105.19
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 59.01,
    y1: 76.84,
    x2: 59.01,
    y2: 133.54
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.17,
    y1: 76.84,
    x2: 56.17,
    y2: 105.19
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.34,
    y1: 76.84,
    x2: 53.34,
    y2: 105.19
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 50.5,
    y1: 76.84,
    x2: 50.5,
    y2: 105.19
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 47.67,
    y1: 76.84,
    x2: 47.67,
    y2: 105.19
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 44.83,
    y1: 76.84,
    x2: 44.83,
    y2: 119.36
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 42,
    y1: 76.84,
    x2: 42,
    y2: 105.19
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 39.17,
    y1: 76.84,
    x2: 39.17,
    y2: 105.19
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 36.33,
    y1: 76.84,
    x2: 36.33,
    y2: 105.19
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 33.5,
    y1: 76.84,
    x2: 33.5,
    y2: 105.19
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 30.66,
    y1: 76.84,
    x2: 30.66,
    y2: 133.54
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 27.83,
    y1: 76.84,
    x2: 27.83,
    y2: 105.19
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.99,
    y1: 76.84,
    x2: 24.99,
    y2: 105.19
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.16,
    y1: 76.84,
    x2: 22.16,
    y2: 105.19
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.32,
    y1: 76.84,
    x2: 19.32,
    y2: 105.19
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.49,
    y1: 76.84,
    x2: 16.49,
    y2: 119.36
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.65,
    y1: 76.84,
    x2: 13.65,
    y2: 105.19
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 10.82,
    y1: 76.84,
    x2: 10.82,
    y2: 105.19
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.98,
    y1: 76.84,
    x2: 7.98,
    y2: 105.19
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.15,
    y1: 76.84,
    x2: 5.15,
    y2: 105.19
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.32,
    y1: 0.25,
    x2: 2.32,
    y2: 133.54
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 48.5,
    x2: 257.43,
    y2: 48.5
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 51.33,
    x2: 229.09,
    y2: 51.33
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 54.17,
    x2: 229.09,
    y2: 54.17
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 57,
    x2: 229.09,
    y2: 57
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 59.84,
    x2: 229.09,
    y2: 59.84
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 62.67,
    x2: 243.26,
    y2: 62.67
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 65.51,
    x2: 229.09,
    y2: 65.51
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 68.34,
    x2: 229.09,
    y2: 68.34
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 71.18,
    x2: 229.09,
    y2: 71.18
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 74.01,
    x2: 229.09,
    y2: 74.01
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 76.85,
    x2: 257.43,
    y2: 76.85
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 20.12,
    x2: 257.43,
    y2: 20.12
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 22.96,
    x2: 229.09,
    y2: 22.96
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 25.79,
    x2: 229.09,
    y2: 25.79
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 28.63,
    x2: 229.09,
    y2: 28.63
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 31.46,
    x2: 229.09,
    y2: 31.46
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 34.3,
    x2: 243.26,
    y2: 34.3
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 37.13,
    x2: 229.09,
    y2: 37.13
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 39.96,
    x2: 229.09,
    y2: 39.96
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 42.8,
    x2: 229.09,
    y2: 42.8
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 45.63,
    x2: 229.09,
    y2: 45.63
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 0.25,
    x2: 229.09,
    y2: 0.25
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.28,
    y1: 0.25,
    x2: 229.09,
    y2: 0.25
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 3.08,
    x2: 229.09,
    y2: 3.08
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 5.92,
    x2: 243.26,
    y2: 5.92
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 8.75,
    x2: 229.09,
    y2: 8.75
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 11.59,
    x2: 229.09,
    y2: 11.59
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 14.42,
    x2: 229.09,
    y2: 14.42
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 200.74,
    y1: 17.26,
    x2: 229.09,
    y2: 17.26
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.31,
    y1: 5.92,
    x2: 3.31,
    y2: 5.92
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 5.29,
    y1: 5.92,
    x2: 198.63,
    y2: 5.92
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 199.62,
    y1: 5.92,
    x2: 200.62,
    y2: 5.92
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.32,
    y1: 76.84,
    x2: 200.59,
    y2: 76.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPls2);
export default __webpack_public_path__ + "static/media/pls2.6e34c3bd15c734ea2e9d9d3403714a8b.svg";
export { ForwardRef as ReactComponent };